<template>
    <div class="orderHitchhikingDetail">
        <div class="baseinfo box">
            <div class="info-header">
                <div>
                    <span>订单号：</span>
                    <span @dblclick="$utils.dblclickCopy">{{ rowData.orderNo }}</span>
                </div>
            </div>
            <el-descriptions :column="1" size="medium" border>
                <el-descriptions-item label="订单类型">
                    <el-tag :type="rowData.cityType == 1 ? 'warning' : 'success'">{{ rowData.cityType == 1 ? '城际' : '市内' }}</el-tag>
                    <el-tag style="margin-left: 5px;" :type="rowData.poolType == 1 ? 'primary' : 'success'">{{ rowData.poolType == 1 ? '独享' : '拼车' }}</el-tag>
                    <el-tag style="margin-left: 5px;" :type="rowData.bearHighwayFeeType == 2 ? 'info' : ''">{{ rowData.bearHighwayFeeType | filterConst("BEARHIGHWAYFEE") }}</el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="订单状态">
                    <el-tag size="small" :type="rowData.status | filterConst('HITCHHIKINGDAN', 'type')">{{
                        rowData.status |
                        filterConst('HITCHHIKINGDAN') }}</el-tag>
                    <el-tooltip placement="top" style="margin-left: 5px;" v-if="rowData.status == 60">
                        <div slot="content">
                            {{ rowData.cancelChannel | fliterCancelChannel }}:{{ rowData.cancelReason }}
                        </div>
                        <el-icon :size="16" class="el-icon-question"></el-icon>
                    </el-tooltip>
                </el-descriptions-item>
                <el-descriptions-item label="下单乘客">
                    {{ rowData.realPhoneSuffix }} . {{ rowData.passengerNum }}人
                </el-descriptions-item>
                <el-descriptions-item label="订单金额">
                    <span class="util-money">¥{{ rowData.amount }}</span>
                </el-descriptions-item>
                <el-descriptions-item label="计价里程">{{ rowData.distance || 0 }} km</el-descriptions-item>
                <el-descriptions-item label="出发时间">
                    {{ rowData.earliestDepartureTime | filterTime }} - {{ rowData.latestDepartureTime | filterDepartureTime(rowData.earliestDepartureTime) }}
                </el-descriptions-item>
                <el-descriptions-item label="备注">{{ rowData.message || '-' }}</el-descriptions-item>
            </el-descriptions>
            <el-descriptions :column="1" size="medium" border>
                <el-descriptions-item label="司机信息">
                    {{ rowData.driverName || '-' }} (<span @dblclick="$utils.dblclickCopy">{{ rowData.driverPhone }}</span>)
                </el-descriptions-item>
                <el-descriptions-item label="车辆号牌">
                    <!-- <licensePlate v-if="rowData.licenseNo" :licenseNo="rowData.licenseNo"
                        :licenseColor="rowData.licenseColor" :vehicleSeat="rowData.vehicleSeat"></licensePlate>
                        <span v-else>-</span> -->
                        <span v-if="rowData.licenseNo" :style="getPlateStyle(rowData.licenseNo)" @dblclick="$utils.dblclickCopy">{{ formatPlateNumber(rowData.licenseNo) }}</span>
                        <span v-else>-</span>
                </el-descriptions-item>
                <el-descriptions-item label="机构名称">
                    {{ rowData.organizationName || '-' }}
                </el-descriptions-item>
                <el-descriptions-item label="所属渠道">
                    {{ rowData.channelName || '-' }}
                </el-descriptions-item>
            </el-descriptions>
            <el-descriptions :column="1" size="medium" border>
                <el-descriptions-item label="订单来源">
                    {{ rowData.channelAlias | filterConst("HITCHHIKINGCHANNEL") }}
                </el-descriptions-item>
                <el-descriptions-item label="三方订单号"><span @dblclick="$utils.dblclickCopy">{{ rowData.partnerOrderId }}</span></el-descriptions-item>
            </el-descriptions>
        </div>

        <el-tabs v-model="activeName" class="box driver-tabs">
            <!-- 跟踪记录 -->
            <el-tab-pane label="订单跟踪" name="map">
                <orderRecord :orderId="rowData.id" v-if="activeName == 'map'"></orderRecord>
            </el-tab-pane>
            <!-- 订单轨迹 -->
            <el-tab-pane label="订单轨迹" name="order">
                <orderLine :rowData="rowData" v-if="activeName == 'order'"></orderLine>
            </el-tab-pane>
            <!-- 行程录音 -->
            <el-tab-pane label="行程录音" name="audio">
                <orderAudio :rowData="rowData" v-if="activeName == 'audio'"></orderAudio>
            </el-tab-pane>
            <!-- 聊天记录 -->
            <el-tab-pane label="聊天记录" name="chat" style="width: 500px;">
                <div class="blueInfo">
                    * 以下为该订单乘客与司机通过司机端App内的聊天工具的建联记录
                </div>
                <orderChat :orderId="rowData.id" v-if="activeName == 'chat'"></orderChat>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import orderRecord from './orderRecord.vue';
import orderChat from './orderChat.vue';
import orderLine from './orderLine.vue'
import orderAudio from './orderAudio.vue'
export default {
    name: "orderHitchhikingDetail",
    components: {
        orderRecord,
        orderChat,
        orderLine,
        orderAudio
    },
    props: {
        rowData: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    data() {
        return {
            activeName: "map",
        };
    },
    
    methods: {
        handleComplaint() {
            console.log('发起客诉');
            this.$emit('handleComplaint', this.rowData);
        },
        handleClose() {
            this.$emit('handClose');
        },
    },
};
</script>

<style lang="less" scoped>
.orderHitchhikingDetail {
    display: flex;
    gap: 20px;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: var(--bg-color);
    padding: 20px;

    &>.box {
        height: calc(100vh - 80px);
        background: #fff;
        padding: 16px;
        border-radius: 10px;
        overflow-y: auto;

        &::-webkit-scrollbar {
            width: 5px;
        }
    }

    .baseinfo {
        width: 370px;
        flex-shrink: 0;

        .info-header {
            width: 100%;
            line-height: 40px;
            font-size: 16px;
            font-weight: bold;
            user-select: none;
        }

        .status-tag {
            display: flex;
            align-items: center;
            gap: 5px;
        }

        :deep(.el-descriptions) {
            border-radius: 8px;
            position: relative;
            overflow: hidden;
            margin-top: 16px;
        }

        :deep(.el-descriptions)::after {
            content: '';
            pointer-events: none;
            position: absolute;
            inset: 0;
            border-radius: 8px;
            border: 1px solid #EBEEF5;
            z-index: 1;
        }

        :deep(.el-descriptions-row) {
            display: flex;
        }

        :deep(.el-descriptions-item__cell) {
            border-top: 0;
            border-left: 0;
        }

        :deep(.el-descriptions-item__label.is-bordered-label) {
            width: 110px;
            background-color: #FBFBFB;
        }

        :deep(.el-descriptions-item__content) {
            width: 260px;
        }
    }

    .driver-tabs {
        flex: 1;
    }

    /deep/ .el-tabs__content {
        height: calc(100% - 60px);
        overflow-y: auto;
        padding-right: 20px;

        &::-webkit-scrollbar {
            width: 5px;
        }

        &>div {
            width: 100%;
            height: 100%;
        }
    }

    /deep/ .el-tabs__nav-wrap::after {
        height: 1px;
    }
}
</style>